import React, { useEffect } from "react"
import './chatbot.scss'

/**
 * SwiftDoc Chatbot Widget
 * Embedded version that connects to n8n workflow
 */

const SwiftDocChatbot = (function() {
    // Private variables
    let config = {
        webhookUrl: '',
        containerId: 'swiftdoc-chatbot-container',
        welcomeMessage: 'Hello! I\'m the SwiftDoc assistant. How can I help you today?',
        placeholderText: 'Type your message here...',
        chatbotName: 'SwiftDoc Assistant'
    };
    
    let state = {
        isOpen: true,
        messages: [],
        isTyping: false,
        sessionId: null
    };
    
    // DOM elements
    let elements = {
        container: null,
        // chatButton: null,
        chatWindow: null,
        messagesContainer: null,
        inputField: null,
        sendButton: null,
        typingIndicator: null
    };
    
    // Initialize the widget
    function init(userConfig = {}) {
        // Merge user config with default config
        config = { ...config, ...userConfig };
        
        // Generate a session ID if not exists
        state.sessionId = localStorage.getItem('swiftdoc_session_id') || generateSessionId();
        localStorage.setItem('swiftdoc_session_id', state.sessionId);
        
        // Create widget elements
        createWidgetElements();
        
        // Add event listeners
        addEventListeners();

        // toggleChatWindow();

        elements.chatWindow.classList.toggle('active', state.isOpen);
        
        if (state.isOpen) {
            elements.inputField.focus();
        }
        
        // Add welcome message
        addMessage(config.welcomeMessage, 'bot');
    }
    
    // Create widget DOM elements
    function createWidgetElements() {
        // Get container
        elements.container = document.getElementById(config.containerId);
        if (!elements.container) {
            console.error(`Container with ID "${config.containerId}" not found.`);
            return;
        }
        
        // Create widget wrapper
        const widgetWrapper = document.createElement('div');
        widgetWrapper.className = 'swiftdoc-chatbot-widget';
        
        // // Create chat button
        // elements.chatButton = document.createElement('div');
        // elements.chatButton.className = 'swiftdoc-chat-button';
        // elements.chatButton.innerHTML = `
        //     <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        //         <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12z"/>
        //         <path d="M7 9h10M7 12h7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        //     </svg>
        // `;
        
        // Create chat window
        elements.chatWindow = document.createElement('div');
        elements.chatWindow.className = 'swiftdoc-chat-window';
        
        // Create chat header
        const chatHeader = document.createElement('div');
        chatHeader.className = 'swiftdoc-chat-header';
        chatHeader.innerHTML = `
            <div class="swiftdoc-chat-header-title">
                <h3 class="swiftdoc-chat-header-text">${config.chatbotName}</h3>
            </div>
        `;
        
        // Create messages container
        elements.messagesContainer = document.createElement('div');
        elements.messagesContainer.className = 'swiftdoc-chat-messages';
        
        // Create typing indicator
        elements.typingIndicator = document.createElement('div');
        elements.typingIndicator.className = 'swiftdoc-typing-indicator';
        elements.typingIndicator.innerHTML = `
            <div class="swiftdoc-typing-indicator-dot"></div>
            <div class="swiftdoc-typing-indicator-dot"></div>
            <div class="swiftdoc-typing-indicator-dot"></div>
        `;
        elements.messagesContainer.appendChild(elements.typingIndicator);
        
        // Create chat input
        const chatInput = document.createElement('div');
        chatInput.className = 'swiftdoc-chat-input';
        
        elements.inputField = document.createElement('textarea');
        elements.inputField.className = 'swiftdoc-chat-input-field';
        elements.inputField.placeholder = config.placeholderText;
        elements.inputField.rows = 1;
        
        elements.sendButton = document.createElement('button');
        elements.sendButton.className = 'swiftdoc-chat-send-button';
        elements.sendButton.disabled = true;
        elements.sendButton.innerHTML = `
            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>
            </svg>
        `;
        
        chatInput.appendChild(elements.inputField);
        chatInput.appendChild(elements.sendButton);
        
        // Assemble chat window
        elements.chatWindow.appendChild(chatHeader);
        elements.chatWindow.appendChild(elements.messagesContainer);
        elements.chatWindow.appendChild(chatInput);
        
        // Assemble widget
        // widgetWrapper.appendChild(elements.chatButton);
        widgetWrapper.appendChild(elements.chatWindow);
        
        // Add to container
        elements.container.appendChild(widgetWrapper);
    }
    
    // Add event listeners
    function addEventListeners() {
        // Toggle chat window
        // elements.chatButton.addEventListener('click', toggleChatWindow);
        
        // Close chat window
        // elements.chatWindow.querySelector('.swiftdoc-close-button').addEventListener('click', closeChatWindow);
        
        // Minimize chat window
        // elements.chatWindow.querySelector('.swiftdoc-minimize-button').addEventListener('click', closeChatWindow);
        
        // Send message on button click
        elements.sendButton.addEventListener('click', sendMessage);
        
        // Enable/disable send button based on input
        elements.inputField.addEventListener('input', function() {
            elements.sendButton.disabled = !this.value.trim();
            
            // Auto-resize textarea
            this.style.height = 'auto';
            this.style.height = (this.scrollHeight) + 'px';
        });
        
        // Send message on Enter key (but allow Shift+Enter for new line)
        elements.inputField.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' && !e.shiftKey) {
                e.preventDefault();
                if (!elements.sendButton.disabled) {
                    sendMessage();
                }
            }
        });
    }
    
    // Toggle chat window
    function toggleChatWindow() {
        state.isOpen = !state.isOpen;
        elements.chatWindow.classList.toggle('active', state.isOpen);
        
        if (state.isOpen) {
            elements.inputField.focus();
        }
    }
    
    // Close chat window
    function closeChatWindow() {
        state.isOpen = false;
        elements.chatWindow.classList.remove('active');
    }
    
    // Send message to n8n webhook
    function sendMessage() {
        const messageText = elements.inputField.value.trim();
        if (!messageText) return;
        
        // Add user message to chat
        addMessage(messageText, 'user');
        
        // Clear input field
        elements.inputField.value = '';
        elements.inputField.style.height = 'auto';
        elements.sendButton.disabled = true;
        
        // Show typing indicator
        showTypingIndicator();
        
        // Send message to n8n webhook
        fetch(config.webhookUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                sessionId: state.sessionId,
                chatInput: messageText
            })
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        })
        .then(data => {
            // Hide typing indicator
            hideTypingIndicator();
            
            // Add bot response to chat
            if (data && data.output) {
                addMessage(data.output, 'bot');
            } else {
                addMessage('Sorry, I couldn\'t process your request. Please try again.', 'bot');
            }
        })
        .catch(error => {
            console.error('Error:', error);
            
            // Hide typing indicator
            hideTypingIndicator();
            
            // Add error message
            addMessage('Sorry, there was an error connecting to the service. Please try again later.', 'bot');
        });
    }
    
    // Add message to chat
    function addMessage(text, sender) {
        // Create message element
        const messageElement = document.createElement('div');
        messageElement.className = `swiftdoc-message swiftdoc-message-${sender}`;
        
        // Add message text
        messageElement.textContent = text;
        
        // Add timestamp
        const timestamp = document.createElement('div');
        timestamp.className = 'swiftdoc-message-time';
        timestamp.textContent = formatTime(new Date());
        messageElement.appendChild(timestamp);
        
        // Add to messages container before the typing indicator
        elements.messagesContainer.insertBefore(messageElement, elements.typingIndicator);
        
        // Save message to state
        state.messages.push({
            text,
            sender,
            timestamp: new Date()
        });
        
        // Scroll to bottom
        scrollToBottom();
    }
    
    // Show typing indicator
    function showTypingIndicator() {
        state.isTyping = true;
        elements.typingIndicator.classList.add('active');
        scrollToBottom();
    }
    
    // Hide typing indicator
    function hideTypingIndicator() {
        state.isTyping = false;
        elements.typingIndicator.classList.remove('active');
    }
    
    // Scroll messages container to bottom
    function scrollToBottom() {
        elements.messagesContainer.scrollTop = elements.messagesContainer.scrollHeight;
    }
    
    // Format time as HH:MM
    function formatTime(date) {
        return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    }
    
    // Generate a random session ID
    function generateSessionId() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            const r = Math.random() * 16 | 0;
            const v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
    
    // Public API
    return {
        init,
        addMessage,
        toggleChatWindow,
        closeChatWindow
    };
})();

/**
 * SwiftDocN8nAdapter
 * Handles the connection between the widget and the n8n workflow
 */
const SwiftDocN8nAdapter = (function() {
    // Default configuration
    const defaultConfig = {
        webhookId: '', // From the JSON file
        baseUrl: '', // Will be set during initialization
        retryAttempts: 3,
        retryDelay: 1000
    };

    let config = {...defaultConfig};
    
    // Initialize the adapter
    function init(userConfig = {}) {
        config = {...config, ...userConfig};
        
        // If baseUrl is not provided, try to determine it
        if (!config.baseUrl && config.webhookUrl) {
            // Extract base URL from webhook URL
            const url = new URL(config.webhookUrl);
            config.baseUrl = `${url.protocol}//${url.host}`;
        }
        
        return {
            sendMessage: sendMessage
        };
    }
    
    // Send message to n8n webhook
    async function sendMessage(message, sessionId) {
        const webhookUrl = config.webhookUrl || `${config.baseUrl}/webhook/${config.webhookId}`;
        
        // Prepare the payload based on the n8n workflow structure
        const payload = {
            sessionId: sessionId,
            message: message,
            timestamp: new Date().toISOString()
        };
        
        // Send request with retry logic
        return sendWithRetry(webhookUrl, payload);
    }
    
    // Send request with retry logic
    async function sendWithRetry(url, payload, attempt = 1) {
        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });
            
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            
            return await response.json();
        } catch (error) {
            if (attempt < config.retryAttempts) {
                // Wait before retrying
                await new Promise(resolve => setTimeout(resolve, config.retryDelay));
                // Increase delay for next attempt (exponential backoff)
                config.retryDelay *= 1.5;
                // Retry
                return sendWithRetry(url, payload, attempt + 1);
            } else {
                throw error;
            }
        }
    }
    
    // Public API
    return {
        init
    };
})();

const Chatbot = () => {

    useEffect(() => {
        SwiftDocChatbot.init({
            webhookUrl: 'https://swiftdoc.app.n8n.cloud/webhook/7f42b7d7-d545-452f-afc3-b8c50cbc1fd8/chat', // Replace with actual n8n webhook URL
            containerId: 'swiftdoc-chatbot-container'
        });
    }, [])


    return (
        <div id="swiftdoc-chatbot-container"></div>
    )
}






export default Chatbot